import { IsOptional, IsNotEmpty, IsString, MaxLength, IsInt, IsArray, MinLength } from 'class-validator';

export class CollectiveAgreementEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(50)
    name: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsInt()
    maxOvertimeHours: number;

    @IsOptional()
    @IsInt()
    overtimeRange: number;

    @IsOptional()
    @IsInt()
    overtimeLifetime: number;

    @IsOptional()
    @IsInt()
    maxCompensationHours: number;

    @IsOptional()
    @IsInt()
    compensationRange: number;

    @IsOptional()
    @IsInt()
    compensationLifetime: number;

    @IsOptional()
    @IsInt()
    maxFlexHours: number;

    @IsOptional()
    @IsInt()
    flexRange: number;

    @IsOptional()
    @IsInt()
    flexLifetime: number;

    @IsOptional()
    @IsInt()
    maxFlexPerEvent: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    users: Array<string>;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    collectiveAgreementRates: Array<string>;

}
